module.exports = __webpack_public_path__ + "img/paving_work.9f68739e.jpg";